import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const TextBox = styled.div`
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.56;
    letter-spacing: -0.4px;
    max-width: 100%;
    width: 100%;
    word-break: keep-all;
    white-space: pre-wrap;

    ${device.tablet}{
        width: 100%;
        max-width: 700px;
        letter-spacing: -0.4px;
        margin-bottom: 80px;
        font-size: 16px;
        font-weight: 400;
        word-break: keep-all;
    }
    ${device.mobile}{
        width: 100%;
        max-width: 100vw;
        letter-spacing: -0.4px;
        line-height: 2;
        margin-bottom: 30px;
        font-weight: 400;
        font-size: 14px;
        word-break: keep-all;
        white-space: pre-wrap;
    }
`;

const InfoList = styled.ul`
    margin-top: 10px;
    ${device.tablet} {
        
        margin-top: 40px;
     
        //line-height: 2.3rem;
        word-break: keep-all;
    }
`;
const Item = styled.li`
    font-size: 14px;
    line-height: 30px;
    ${device.tablet} {
        font-size: 16px;
    }
    ${device.mobile} {
        font-size: 13px;
        line-height: 20px;
        letter-spacing: -0.5px;
    }
`;
const SectionTextBox = ({textList, list, content}) => {
    return (
        <TextBox>
            {textList}
            {/*{textList&& textList.map((text, index) => (*/}
            {/*    <Txt key={index}>{textList}</Txt>*/}
            {/*))}*/}
            {list && <InfoList>
                {list.map((item, index) => (<Item key={index}>{item}</Item>))}
            </InfoList>}
            {content}
        </TextBox>
    );
};

export default SectionTextBox;
